import { Component, OnDestroy } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-renderer',
  template: `<style>
      .edit-btn {
        color: white;
        background: #3aafe4;
        margin-right: 5px;
      }
      .delete-btn-manager {
        color: white;
        background: red;
        margin-right: 5px;
      }
      .view-btn {
        color: white;
        background: orange;
      }
      i {
        color: white;
      }
      .btn:disabled {
        opacity: 0.5;
      }
      .btn {
        padding: 7px 10px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
      }
      .d-flex {
        display: flex;
      }
      .rca-btn {
        color: white;
        background: #ff7200;
        margin-left: 5px;
      }
       .subtasks-btn {
        color: white;
        background: #4caf50; /* Green for subtasks */
        margin-right: 5px;
        margin-left: 5px;
      }
    </style>
    <div class="d-flex">
      <button
        [hidden]="this.params.data.Task"
        class="view-btn btn custom-tooltip"
        style="background-color:#16cbd0;margin-right:5px"
        [title]="t('QRCode', 'QR Code')"
        mat-icon-button
        matTooltip="QRCode"
        matTooltipPosition="right"
        (click)="onClickQRCode($event)"
      >
        <i class="fa fa-qrcode" aria-hidden="true"></i>
      </button>

      <button
        class="edit-btn btn custom-tooltip "
        [title]="t('Edit', 'Edit')"
        [disabled]="this.params.data.WOStatus == 'Close'"
        mat-icon-button
        pTooltip="Action Detail"
        tooltipPosition="top"
        (click)="onClickEdit($event)"
      >
        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
      </button>

      <button
        class="view-btn btn custom-tooltip"
        [title]="t('View', 'View')"
        style="margin-right:5px"
        mat-icon-button
        matTooltip="View"
        matTooltipPosition="right"
        (click)="onClickView($event)"
      >
        <i class="fa fa-eye" aria-hidden="true"></i>
      </button>

      <!-- <button
        class="view-btn btn custom-tooltip"
        [title]="t('ViewWorkPermit', 'View Work Permit')"
        style="background-color:#d0168b"
        mat-icon-button
        matTooltip="View Work Permit"
        matTooltipPosition="right"
        (click)="onClickViewWorkPermit($event)"
      >
        <i class="fa fa-external-link" aria-hidden="true"></i>
      </button> -->

      <button
        class="rca-btn btn custom-tooltip"
        [title]="t('CreateRCA', 'Create RCA')"
        [hidden]="this.shouldHideRCAButton()"
        mat-icon-button
        matTooltip="Create RCA"
        matTooltipPosition="right"
        (click)="onClickRCA($event)"
      >
        <i class="fa fa-list" aria-hidden="true"></i>
      </button>
      <button
        [hidden]="!this.params.data?.Task && !this.params.data?.WOId"
        class="subtasks-btn btn custom-tooltip"
        [title]="t('SubWorkOrder', 'Sub Work Order')"
        mat-icon-button
        matTooltip="View Sub Work Order"
        matTooltipPosition="right"
        (click)="handleSubtask($event)"
      >
        <i class="fa fa-tasks" aria-hidden="true"></i>
      </button>
    </div> `,
})
export class ActionEditDeleteViewBtnRendererManager
  implements ICellRendererAngularComp, OnDestroy {
  constructor(public translate: TranslateService) {}

  /** "PM.<key>" from the JSON files -> flat key -> English fallback. */
  public t(key: string, fallback: string): string {
    for (const candidate of ['PM.' + key, key]) {
      const value = this.translate.instant(candidate);
      if (typeof value === 'string' && value !== candidate) {
        return value;
      }
      if (value && typeof value === 'object' && typeof value.title === 'string') {
        return value.title;
      }
    }
    return fallback;
  }

  params: any;
  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }

  agInit(params: any): void {
    this.params = params;
    console.log(this.params, 'params manager');
  }

  shouldHideRCAButton(): boolean {
    const data = this.params?.data;
    if (!data) {
      return true;
    }

    const hasIntegrationWithHeaderId =
      data.ATIntegration != null && data.ATIntegration.HeaderId !== 0;

    const isWOStatusClosedOrComplete =
      data.WOStatus === 'Complete' || data.WOStatus === 'Close';

    return hasIntegrationWithHeaderId || isWOStatusClosedOrComplete;
  }

  onClickEdit($event: any): any {
    if (this.params.onClickEdit instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
        // ...something
      };
      this.params.onClickEdit(params);
    }
  }
  onClickRCA($event: any): any {
    if (this.params.onClickRCA instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
        // ...something
      };
      this.params.onClickRCA(params);
    }
  }
  handleSubtask($event: any): void {
    if (this.params?.onClickSubtask) {
      this.params.onClickSubtask(this.params.data);
    } else {
    }
  }
  // onClickDelete($event: any): any {
  //   if (this.params.onClickDelete instanceof Function) {
  //     const params = {
  //       event: $event,
  //       rowData: this.params.node.data,
  //       index: this.params.node.rowIndex,
  //     };
  //     this.params.onClickDelete(params);
  //   }
  // }
  onClickView($event: any): any {
    if (this.params.onClickView instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
        // ...something
      };
      this.params.onClickView(params);
    }
  }
  // onClickViewWorkPermit($event: any): any {
  //   if (this.params.onClickView instanceof Function) {
  //     // put anything into params u want pass into parents component
  //     const params = {
  //       event: $event,
  //       rowData: this.params.node.data,
  //       index: this.params.node.rowIndex,
  //       // ...something
  //     };
  //     this.params.onClickViewWorkPermit(params);
  //   }
  // }
  onClickQRCode($event: any): any {
    if (this.params.onClickQRCode instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
        // ...something
      };
      this.params.onClickQRCode(params);
    }
  }

  ngOnDestroy(): any {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
